import type { AnalyticsEvent } from "../types/analyticsEvent.types";
import { HallowAnalyticsHandler } from "../types/enums/hallowAnalyticsHandler.enum";
import { consoleLogPackagesAnalytics } from "./consoleLogPackagesAnalytics";

type TrackCrossPlatformProps = {
  event: AnalyticsEvent;
  handler?: HallowAnalyticsHandler;
};

export const trackCrossPlatform = ({
  event,
  handler = HallowAnalyticsHandler.Track,
}: TrackCrossPlatformProps) => {
  if (typeof window !== "undefined") {
    if ("webkit" in window)
      window.webkit.messageHandlers?.[handler]?.postMessage(event);
    if ("Android" in window) window.Android?.[handler]?.(JSON.stringify(event));
    /** For Web Development */
    if (!("Android" in window) && !("webkit" in window))
      consoleLogPackagesAnalytics({
        heading: "trackCrossPlatform",
        message: `${event.event}: ${JSON.stringify(event.properties)}`,
      });
  }
};
